import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IChangePassword } from '../interfaces/IChangePassword';
import { IConfirmEmail } from '../interfaces/IConfirmarEmail';
import { Injectable } from '@angular/core';
import { IUser } from '../interfaces/IUser';
import { Usuario } from '../models/usuario';
import { environment } from 'src/environments/environment';
import { TokenService } from '../utils/token.service';

@Injectable({
  providedIn: 'root'
})

export class UsuariosService {

  private usuarioserveruri: string;
  private usuarioserveruri2: string;
  private apiUrl = environment.apiUrl; 

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.usuarioserveruri = this.apiUrl + '/' + this.configService.UsuarioURI;
    this.usuarioserveruri2 = this.apiUrl + '/' + this.configService.UsuarioURI2;
  }
  
  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }
  
  cRoles() {
    return this.httpCliente.get(this.usuarioserveruri + 'CRoles', {headers:this.getHeaders()});
  }

  changePassword(model: IChangePassword) {
    return this.httpCliente.post(this.usuarioserveruri2 + 'ChangePassword', model, {headers:
      { 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r'}
    });
  }

  login(model: IUser) {
    return this.httpCliente.post(this.usuarioserveruri2 + 'Login', model,{ headers: 
      { 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r'}
    });
  }

  cNuevaClave(userName: string) {
    return this.httpCliente.post(this.usuarioserveruri2 + 'CNuevaClave', userName, { headers:{ 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r'} });
  }

  cNuevaClaveVerificacion(model: IUser) {
    return this.httpCliente.post(this.usuarioserveruri2 + 'CNuevaClaveVerificacion', model, {headers:{ 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r'}});
  }

  confirmEmail(model: IConfirmEmail) {
    return this.httpCliente.post(this.usuarioserveruri2 + 'ConfirmEmail', model, {headers:{ 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r'}});
  }

  cUsuarios() {
    return this.httpCliente.get(this.usuarioserveruri + 'CUsuarios', {headers:this.getHeaders()});
  }

  cUsuario(userId: string) {
    return this.httpCliente.get(this.usuarioserveruri + 'CUsuario?userId=' + userId, {headers:this.getHeaders()});
  }

  aUsuario(model: Usuario) {
    return this.httpCliente.post(this.usuarioserveruri + 'AUsuario', model, {headers:this.getHeaders()});
  }

  cUsuarioDB(codigo: number, userName: string) {
    return this.httpCliente.get(this.usuarioserveruri + 'CUsuarioDB?codigo=' + codigo + "&userName=" + userName, {headers:this.getHeaders()});
  }

  mUsuario(userName: string, model: Usuario) {
    return this.httpCliente.post(this.usuarioserveruri + 'MUsuario?userName=' + userName, model, {headers:this.getHeaders()});
  }
  bUsuario(model: Usuario) {
    return this.httpCliente.delete(this.usuarioserveruri + 'BUsuario?codigo=' + model.codigo + "&userName=" + model.userName, {headers:this.getHeaders()});
  }

  cDivisionesPaises(idsPaises: string) {
    return this.httpCliente.get(this.usuarioserveruri + 'CDivisionesPaises?idsPaises=' + idsPaises, {headers:this.getHeaders()});
  }

}
